import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageContext'; // Importamos el hook de idioma

const APYGroupServices = () => {
  // Hook de idioma
  const { t } = useLanguage();
  
  // Hook de navegación
  const navigate = useNavigate();
  
  // Estados para las animaciones y comportamiento interactivo
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeService, setActiveService] = useState(null);
  const [hoveredService, setHoveredService] = useState(null);
  const [visibleSections, setVisibleSections] = useState({
    hero: false,
    services: false,
    process: false,
    partnerships: false,
    testimonials: false
  });

  // Referencias para observar las secciones
  const heroRef = useRef(null);
  const servicesRef = useRef(null);
  const processRef = useRef(null);
  const partnershipsRef = useRef(null);
  const testimonialsRef = useRef(null);

  // Información de servicios
  const services = [
    {
      id: 'representation',
      title: t('service.representation.title'),
      shortDesc: t('service.representation.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
      ),
      description: t('service.representation.desc'),
      features: [
        'Negociación de contratos profesionales',
        'Gestión con clubes internacionales',
        'Planificación estratégica de carrera',
        'Transparencia y confianza absoluta'
      ],
      image: '/api/placeholder/600/400',
      color: 'from-red-600 to-red-800'
    },
    {
      id: 'intermediation',
      title: t('service.intermediation.title'),
      shortDesc: t('service.intermediation.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
        </svg>
      ),
      description: t('service.intermediation.desc'),
      features: [
        'Red global de contactos en clubes profesionales',
        'Negociación de transferencias y préstamos',
        'Identificación de oportunidades estratégicas',
        'Relaciones de confianza con directivos deportivos'
      ],
      image: 'https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/planeta.png',
      color: 'from-red-700 to-red-900'
    },
    {
      id: 'publicity',
      title: t('service.publicity.title'),
      shortDesc: t('service.publicity.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"></path>
        </svg>
      ),
      description: t('service.publicity.desc'),
      features: [
        'Gestión profesional de redes sociales',
        'Negociación con marcas y patrocinadores',
        'Desarrollo de imagen de marca personal',
        'Estrategias de comunicación efectivas'
      ],
      image: '/api/placeholder/600/400',
      color: 'from-red-600 to-red-800'
    },
    {
      id: 'coaching',
      title: t('service.coaching.title'),
      shortDesc: t('service.coaching.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
        </svg>
      ),
      description: t('service.coaching.desc'),
      features: [
        'Entrenamiento en habilidades mentales',
        'Gestión del estrés competitivo',
        'Desarrollo de liderazgo',
        'Preparación para la vida post-carrera deportiva'
      ],
      image: '/api/placeholder/600/400',
      color: 'from-red-700 to-red-900'
    },
    {
      id: 'legal',
      title: t('service.legal.title'),
      shortDesc: t('service.legal.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path>
        </svg>
      ),
      description: t('service.legal.desc'),
      features: [
        'Revisión y elaboración de contratos profesionales',
        'Asesoría en derechos de imagen',
        'Resolución de conflictos deportivos',
        'Protección de derechos e intereses'
      ],
      image: '/api/placeholder/600/400',
      color: 'from-red-600 to-red-800'
    },
    {
      id: 'international',
      title: t('service.international.title'),
      shortDesc: t('service.international.short'),
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      ),
      description: t('service.international.desc'),
      features: [
        'Especialistas en mercado asiático, especialmente Japón',
        'Pruebas en clubes internacionales',
        'Adaptación cultural y lingüística',
        'Gestión integral de transferencias internacionales'
      ],
      image: '/api/placeholder/600/400',
      color: 'from-red-700 to-red-900'
    }
  ];

  // Datos de alianzas estratégicas
  const partnerships = [
    {
      id: 'fcreys9',
      name: 'FCREYS9 Football Academy',
      logo: 'https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/FCREY9_LOGO-768x768.png',
      location: 'Perú',
      description: 'Academia de fútbol especializada en formar jóvenes talentos con metodologías avanzadas y enfoque internacional.',
      color: 'bg-gradient-to-br from-blue-700 to-blue-900'
    },
    {
      id: 'kaoru',
      name: 'Kaoru Morozoka',
      logo: 'https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/kaoru_morioka_logo-1024x1024.png',
      location: 'Japón',
      description: 'Consultora especializada en el mercado japonés y asiático, facilitando oportunidades para futbolistas latinoamericanos.',
      color: 'bg-gradient-to-br from-red-700 to-red-900'
    },
    {
      id: 'jleague',
      name: 'Clubes J-League',
      logo: '/api/placeholder/220/120',
      location: 'Japón',
      description: 'Relaciones directas con clubes de primera y segunda división japonesa para pruebas y transferencias de talentos.',
      color: 'bg-gradient-to-br from-green-700 to-green-900'
    }
  ];
  
  // Datos para la sección de proceso
  const processSteps = [
    {
      number: '01',
      title: 'Evaluación',
      description: 'Análisis completo del perfil, capacidades y potencial de desarrollo del atleta.'
    },
    {
      number: '02',
      title: 'Planificación',
      description: 'Diseño de una estrategia personalizada para el desarrollo deportivo y profesional.'
    },
    {
      number: '03',
      title: 'Representación',
      description: 'Gestión activa de oportunidades y negociaciones con clubes nacionales e internacionales.'
    },
    {
      number: '04',
      title: 'Desarrollo',
      description: 'Acompañamiento continuo para maximizar el rendimiento y crecimiento profesional.'
    }
  ];
  
  // Datos de testimonios
  const testimonials = [
    {
      id: 1,
      quote: "AFY Group transformó mi carrera. Su visión internacional me llevó a jugar en Japón, algo que nunca imaginé posible.",
      name: "Carlos Martínez",
      position: "Delantero, V-Varen Nagasaki",
      image: "/api/placeholder/80/80"
    },
    {
      id: 2,
      quote: "No solo me consiguieron un contrato, sino que se preocuparon por mi adaptación cultural y bienestar. Son mucho más que agentes deportivos.",
      name: "Luis Peralta",
      position: "Mediocampista, Shonan Bellmare",
      image: "/api/placeholder/80/80"
    }
  ];

  // Efecto para simular carga inicial
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  // Observador de intersección para activar animaciones al hacer scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: "0px 0px -100px 0px"
    };
    
    const handleIntersect = (entries) => {
      entries.forEach(entry => {
        const { id } = entry.target;
        if (entry.isIntersecting) {
          setVisibleSections(prev => ({ ...prev, [id]: true }));
        }
      });
    };
    
    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    
    const refs = [
      { ref: heroRef, id: 'hero' },
      { ref: servicesRef, id: 'services' },
      { ref: processRef, id: 'process' },
      { ref: partnershipsRef, id: 'partnerships' },
      { ref: testimonialsRef, id: 'testimonials' }
    ];
    
    refs.forEach(({ ref, id }) => {
      if (ref.current) {
        ref.current.id = id;
        observer.observe(ref.current);
      }
    });
    
    return () => {
      refs.forEach(({ ref }) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, []);

  // Función para manejar la selección de servicios
  const handleServiceClick = (serviceId) => {
    setActiveService(activeService === serviceId ? null : serviceId);
  };
  
  // Función para ir a la página de contacto
  const goToContact = () => {
    navigate('/contacto');
  };

  return (
    <div className="bg-black text-white min-h-screen overflow-hidden">
      {/* Hero Section Mejorada */}
      <section 
        ref={heroRef}
        className="relative h-[60vh] md:h-[70vh] flex items-center justify-center overflow-hidden"
      >
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/70 to-black/90 z-10"></div>
          <img 
            src="https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/estadio.png" 
            alt="Estadio" 
            className="w-full h-full object-cover filter brightness-50"
          />
        </div>
        
        {/* Elementos de diseño */}
        <div className="absolute inset-0 z-5">
          <div className="absolute left-0 top-0 w-full h-full overflow-hidden opacity-30">
            <div className="absolute -left-40 -top-40 w-80 h-80 bg-red-600 rounded-full filter blur-3xl"></div>
            <div className="absolute right-0 bottom-0 w-96 h-96 bg-red-600 rounded-full filter blur-3xl"></div>
          </div>
        </div>
        
        <div className={`relative z-10 container mx-auto px-6 text-center transform transition-all duration-1000 ease-out ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-wide">
            {t('services.title')}
          </h1>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-8"></div>
          
          <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-300 mt-8 leading-relaxed mb-12">
            {t('services.subtitle')}
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="#services" 
              className="px-8 py-3 bg-red-600 rounded-full text-white font-bold transition-all duration-300 hover:bg-red-700 hover:shadow-lg hover:shadow-red-600/20 transform hover:-translate-y-1"
            >
              {t('services.cta.discover')}
            </a>
            <button 
              onClick={goToContact}
              className="px-8 py-3 border border-white/30 rounded-full text-white font-bold transition-all duration-300 hover:bg-white/10 hover:border-white transform hover:-translate-y-1"
            >
              {t('services.cta.contact')}
            </button>
          </div>
          
          <div className="absolute bottom-10 left-0 right-0 animate-bounce">
            <svg className="w-8 h-8 mx-auto text-white opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </section>

      {/* Services Section Mejorada */}
      <section 
        ref={servicesRef}
        className="py-24 md:py-32 relative bg-gradient-to-b from-black to-gray-950"
      >
        <div className="absolute top-0 right-0 w-96 h-96 bg-red-600/10 rounded-full filter blur-3xl -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-600/5 rounded-full filter blur-3xl translate-y-1/2 -translate-x-1/3"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className={`text-center mb-20 transition-all duration-1000 ${visibleSections.services ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10'}`}>
            <h2 className="text-4xl font-black mb-6">{t('services.section.title')}</h2>
            <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
            <p className="max-w-3xl mx-auto text-lg text-gray-300">
              {t('services.section.desc')}
            </p>
          </div>
          
          {/* Servicios en grid con hover cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div 
                key={service.id}
                className={`group relative rounded-xl overflow-hidden transition-all duration-500 cursor-pointer transform ${
                  visibleSections.services ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
                } hover:shadow-2xl hover:shadow-red-600/10 hover:-translate-y-2`}
                style={{ 
                  transitionDelay: `${index * 100}ms`,
                  height: '100%',
                }}
                onMouseEnter={() => setHoveredService(service.id)}
                onMouseLeave={() => setHoveredService(null)}
                onClick={() => handleServiceClick(service.id)}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} transition-all duration-500 ${hoveredService === service.id ? 'opacity-90' : 'opacity-100'}`}></div>
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300"></div>
                
                <div className="relative z-10 p-8 h-full flex flex-col">
                  {/* Icono del servicio */}
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110 backdrop-blur-sm">
                    <div className="text-white">
                      {service.icon}
                    </div>
                  </div>
                  
                  {/* Título y descripción del servicio */}
                  <h3 className="text-2xl font-bold mb-2 transition-transform duration-300 group-hover:-translate-y-1">{service.title}</h3>
                  <p className="text-white/80 mb-6">{service.shortDesc}</p>
                  
                  {/* Indicador de ver más */}
                  <div className="mt-auto flex items-center text-sm font-medium opacity-70 group-hover:opacity-100 transition-all duration-300">
                    <span className="mr-2">{t('services.details')}</span>
                    <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Modal para servicios */}
          {activeService && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90" onClick={() => setActiveService(null)}>
              <div 
                className="bg-gradient-to-b from-gray-900 to-black rounded-xl overflow-hidden max-w-5xl w-full max-h-[90vh] flex flex-col md:flex-row shadow-2xl animate-fadeIn"
                onClick={(e) => e.stopPropagation()}
              >
                <button 
                  onClick={() => setActiveService(null)}
                  className="absolute top-4 right-4 z-50 bg-white/10 rounded-full w-10 h-10 flex items-center justify-center text-white hover:bg-white/20 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
                
                <div className="md:w-1/2 relative h-60 md:h-auto">
                  <div className="bg-red-600/20 absolute inset-0 z-0"></div>
                  <img 
                    src={services.find(s => s.id === activeService)?.image} 
                    alt={services.find(s => s.id === activeService)?.title} 
                    className="w-full h-full object-cover z-10 relative"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent h-1/3"></div>
                  
                  <div className="absolute top-0 left-0 m-6">
                    <div className="bg-red-600 text-white text-xs font-bold uppercase px-3 py-1 rounded-full">
                      {t('services.premiumService')}
                    </div>
                  </div>
                </div>
                
                <div className="md:w-1/2 p-8 flex flex-col max-h-[60vh] md:max-h-[90vh] overflow-y-auto">
                  <h2 className="text-3xl font-bold mb-4">
                    {services.find(s => s.id === activeService)?.title}
                  </h2>
                  
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {services.find(s => s.id === activeService)?.description}
                  </p>
                  
                  <h3 className="text-xl font-semibold mb-4 text-red-600">{t('services.mainFeatures')}</h3>
                  <ul className="mb-8 space-y-3">
                    {services.find(s => s.id === activeService)?.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center">
                        <div className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center mr-3 shrink-0">
                          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <div className="mt-auto">
                    <button 
                      onClick={goToContact}
                      className="w-full bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-full transition-colors duration-300 font-semibold"
                    >
                      {t('services.requestInfo')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      
      {/* Process Section (Nueva) */}
      <section 
        ref={processRef}
        className="py-24 md:py-32 relative bg-gradient-to-b from-gray-950 to-black"
      >
        <div className="container mx-auto px-6 relative z-10">
          <div className={`text-center mb-20 transition-all duration-1000 ${visibleSections.process ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10'}`}>
            <h2 className="text-4xl font-black mb-6">{t('services.process.title')}</h2>
            <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
            <p className="max-w-3xl mx-auto text-lg text-gray-300">
              {t('services.process.desc')}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8 relative">
            {/* Línea conectora horizontal */}
            <div className="absolute top-1/4 left-0 right-0 h-1 bg-red-600/30 hidden lg:block"></div>
            
            {processSteps.map((step, index) => (
              <div 
                key={index}
                className={`relative transition-all duration-1000 transform ${
                  visibleSections.process ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                {/* Círculo numerado */}
<div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center mx-auto mb-6 text-2xl font-bold relative z-20">
  {step.number}
</div>

<div className="bg-gray-900 rounded-xl p-6 text-center hover:bg-gray-800 transition-colors duration-300 relative z-10">
  <h3 className="text-xl font-bold mb-3">{step.title}</h3>
  <p className="text-gray-400">{step.description}</p>
</div>
</div>
))}
</div>

<div className={`mt-16 p-8 md:p-12 bg-gradient-to-r from-red-900/30 to-red-800/30 rounded-2xl backdrop-blur-sm border border-red-900/30 transition-all duration-1000 delay-500 ${
  visibleSections.process ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
}`}>
  <div className="flex flex-col md:flex-row items-center">
    <div className="md:w-1/4 mb-6 md:mb-0 flex justify-center">
      <div className="w-24 h-24 rounded-full bg-red-600 flex items-center justify-center">
        <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
        </svg>
      </div>
    </div>
    <div className="md:w-3/4">
      <h3 className="text-2xl font-bold mb-3 text-center md:text-left">{t('services.commitment.title')}</h3>
      <p className="text-gray-300 leading-relaxed">
        {t('services.commitment.desc')}
      </p>
    </div>
  </div>
</div>
</div>
</section>

{/* Strategic Partnerships Section Mejorada */}
<section 
ref={partnershipsRef}
className="py-24 md:py-32 relative bg-gradient-to-b from-black to-gray-950"
>
<div className="absolute inset-0 overflow-hidden">
  <div className="absolute top-0 left-0 w-full h-full bg-pattern-grid opacity-5"></div>
</div>

<div className="container mx-auto px-6 relative z-10">
  <div className={`text-center mb-20 transition-all duration-1000 ${visibleSections.partnerships ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10'}`}>
    <h2 className="text-4xl font-black mb-6">{t('services.partnerships.title')}</h2>
    <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
    <p className="text-lg max-w-3xl mx-auto text-gray-300">
      {t('services.partnerships.desc')}
    </p>
  </div>
  
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    {partnerships.map((partner, index) => (
      <div 
        key={partner.id}
        className={`relative rounded-xl overflow-hidden transition-all duration-1000 transform ${
          visibleSections.partnerships ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
        } hover:shadow-2xl hover:shadow-red-600/10 hover:-translate-y-2 group`}
        style={{ transitionDelay: `${index * 200}ms` }}
      >
        <div className={`absolute inset-0 ${partner.color} opacity-90 group-hover:opacity-100 transition-opacity duration-300`}></div>
        <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-300"></div>
        
        <div className="relative z-10 p-8 h-full flex flex-col">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 mb-6 w-fit mx-auto">
            <img 
              src={partner.logo} 
              alt={partner.name} 
              className="h-10 w-auto"
            />
          </div>
          
          <h3 className="text-xl font-bold mb-2 text-center">{partner.name}</h3>
          <div className="mb-4 text-center">
            <span className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-3 py-1 text-sm">
              {partner.location}
            </span>
          </div>
          
          <p className="text-center text-white/80 mb-6">{partner.description}</p>
          
          <div className="mt-auto text-center">
            <button className="px-6 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full text-sm transition-colors duration-300 inline-flex items-center">
              <span>{t('services.partnerships.moreInfo')}</span>
              <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
  
  <div className={`mt-24 text-center transition-all duration-1000 delay-500 ${
    visibleSections.partnerships ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}>
    <div className="p-8 md:p-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <img src="https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/planeta.png" alt="World Map" className="w-full h-full object-cover" />
      </div>
      
      <div className="relative z-10">
        <h3 className="text-2xl md:text-3xl font-bold mb-6">{t('services.global.title')}</h3>
        <p className="text-lg max-w-3xl mx-auto mb-8 text-gray-300">
          {t('services.global.desc')}
        </p>
        
        <button 
          onClick={goToContact}
          className="px-10 py-3 bg-red-600 hover:bg-red-700 text-white rounded-full text-lg font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg hover:shadow-red-600/20"
        >
          {t('services.global.cta')}
        </button>
      </div>
    </div>
  </div>
</div>
</section>

{/* Testimonials Section (Nueva) */}
<section 
ref={testimonialsRef}
className="py-24 md:py-32 relative bg-gradient-to-b from-gray-950 to-black"
>
<div className="container mx-auto px-6 relative z-10">
  <div className={`text-center mb-20 transition-all duration-1000 ${visibleSections.testimonials ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10'}`}>
    <h2 className="text-4xl font-black mb-6">{t('services.testimonials.title')}</h2>
    <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
  </div>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
    {testimonials.map((testimonial, index) => (
      <div 
        key={testimonial.id}
        className={`bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-8 transition-all duration-1000 transform ${
          visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        } hover:shadow-xl relative overflow-hidden group`}
        style={{ transitionDelay: `${index * 200}ms` }}
      >
        <div className="absolute -top-6 -left-6 text-9xl text-red-600/10 font-serif">"</div>
        <div className="relative z-10">
          <p className="text-lg italic mb-6 text-gray-300">{testimonial.quote}</p>
          
          <div className="flex items-center">
            <div className="mr-4">
              <img 
                src={testimonial.image} 
                alt={testimonial.name} 
                className="w-14 h-14 rounded-full object-cover border-2 border-red-600"
              />
            </div>
            <div>
              <h4 className="font-bold text-lg">{testimonial.name}</h4>
              <p className="text-red-500">{testimonial.position}</p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
  
  <div className={`mt-20 text-center transition-all duration-1000 delay-500 ${
    visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}>
    <button 
      onClick={goToContact}
      className="inline-flex items-center justify-center px-10 py-4 border-2 border-red-600 text-red-600 rounded-full text-lg font-semibold hover:bg-red-600 hover:text-white transition-all duration-300 group"
    >
      {t('services.testimonials.cta')}
      <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
      </svg>
    </button>
  </div>
</div>
</section>

{/* CSS Animations and Patterns */}
<style jsx>{`
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-pulse {
  animation: pulse 2s infinite;
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}

.bg-grid-pattern {
  background-size: 30px 30px;
  background-image:
    linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
}

.bg-pattern-grid {
  background-size: 30px 30px;
  background-image:
    linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
}
`}</style>
</div>
);
};

export default APYGroupServices;